module.exports = __webpack_public_path__ + "static/media/YIELD YESTERDAY.f25d478e.png";